import React from 'react'
import {
  OmwDropdownMenu,
  OmwProgress,
  OmwSpinner,
  OmwTooltip,
  OmwButton,
  type OmwMenuItem,
  type OmwDropdownMenuConfig,
} from 'components/ui'

import i18n from 'i18n'
import classNames from 'classnames'

import { formatBytes } from 'utils/ui/core'

import downIcon from 'assets/images/chevron-down-gray-24.svg'
import closeIcon from 'assets/images/icon-close-round.svg'

import FTIcon from '../helper/FTIcon'

import styles from './style.module.scss'

interface AttachmentObj {
  name: string
  size: number | string
  mime_type: string
  enable_preview?: boolean
  enable_open?: boolean
  enable_save_as?: boolean
  enablePreview?: boolean
  enableOpen?: boolean
  enableSaveAs?: boolean
}

interface AttachmentApi {
  setProgressCB: (callback: (evt: any, percent: number) => void) => void
  download: (callback?: (ret: any) => void) => void
  downloadFile: () => void
  showPreview: () => void
  open: () => void
  saveAs: () => void
  saveAndOpen: () => void
  showInFolder: () => void
  cancelDownload: () => void
}

interface AttachmentProps {
  attachmentObj: AttachmentObj
  api: AttachmentApi
  enableDelete?: boolean
  downloadable?: boolean
}

interface AttachmentState {
  percent: number
  isEnabled: boolean
  thumbUrl: string | null
  thumbLoading: boolean
}

class Attachment extends React.Component<AttachmentProps, AttachmentState> {
  state: AttachmentState = {
    percent: -1,
    isEnabled: true,
    thumbUrl: null,
    thumbLoading: false,
  }

  percent: number = -1
  ref?: HTMLDivElement
  downloadObj?: any

  componentDidMount() {
    const { /* attachmentObj, */ api } = this.props
    // const { name, mime_type: type } = attachmentObj

    api.setProgressCB(this.onProgress)

    i18n.on('languageChanged', this.onLanguageChanged)
  }

  // componentDidUpdate(prevProps) {
  //   const { file } = this.props
  //
  //   if (prevProps != null && prevProps.file !== file) {
  //   }
  // }

  componentWillUnmount() {
    i18n.off('languageChanged', this.onLanguageChanged)
  }

  onLanguageChanged = () => {
    this.forceUpdate()
  }

  onProgress = (evt: any, percent: number) => {
    console.log('onProgress - ', evt, percent)

    // console.log(' !!!!!! 2 -  ', this.state)

    this.percent = percent
    this.setState({
      percent,
    })

    // console.log(' !!!!!! 3 -  ', this.state)

    if (percent >= 100) {
      setTimeout(() => {
        this.downloadEnded()
        // console.log(' !!!!!! 4 -  ', this.state)
      }, 500)
    }
  }

  downloadEnded = () => {
    this.percent = -1
    this.setState({
      percent: -1,
      isEnabled: true,
    })
  }

  setFileElem = (ref: HTMLDivElement | null) => {
    if (ref != null) {
      this.ref = ref
      // console.log(' ---- ref ---- ', ref, ref.innerText)
      ref.style.visibility = 'hidden'

      const elems = ref.querySelectorAll('span')
      if (elems.length > 0) {
        requestAnimationFrame(() => {
          // const w = elems[1].offsetWidth // + 1
          let w = elems[1].offsetWidth // + 1;
          const wStr = window.getComputedStyle(elems[1], null).width
          if (wStr.substring(wStr.length - 2) === 'px') {
            const num = wStr.substring(0, wStr.length - 2)
            w = window.parseFloat(num)
          }
          if (ref.offsetWidth > w) {
            elems[1].style.maxWidth = `${w}px`
            elems[0].style.maxWidth = `calc(100% - ${w}px)`
          }
          ref.style.visibility = 'visible'
        })
      }
    }
  }

  download = (onDownload?: (ret: any) => void) => {
    const { api } = this.props

    // download 결과를 state(downloadObj)로 흡수해 data-blob-url attribute 갱신.
    // sweep은 viewer iframe outerHTML도 검사하므로, 마운트된 컴포넌트의 attribute가
    // 보호 신호로 작동한다.
    api.download((ret: any) => {
      if (ret != null) {
        this.downloadObj = ret
        this.forceUpdate()
      }
      if (onDownload != null) {
        onDownload(ret)
      }
    })
  }

  // preDownload = () => {
  //   this.download((ret) => {
  //     this.downloadObj = ret
  //
  //     const { attachmentObj } = this.props
  //
  //     const newFile = {
  //       ...file,
  //     }
  //
  //     if (ret.newFileName != null) {
  //       newFile.name = ret.newFileName
  //     }
  //
  //     this.setState({
  //       file: newFile,
  //       thumbLoading: false,
  //     })
  //   })
  // }

  downloadFile = () => {
    const { api } = this.props
    api.downloadFile()
  }

  onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const { attachmentObj } = this.props
    const { enable_preview, enable_open, enablePreview, enableOpen } = attachmentObj

    if (enableOpen === true || enable_open === true) {
      this.open()
    } else if (enablePreview === true || enable_preview === true) {
      this.showPreview()
    } else {
      this.download()
    }

    e.preventDefault()
    e.stopPropagation()
  }

  showPreview = () => {
    const { api } = this.props
    api.showPreview()
  }

  open = () => {
    const { api } = this.props
    api.open()
  }

  saveAs = () => {
    const { api } = this.props
    api.saveAs()
  }

  saveAndOpen = () => {
    const { api } = this.props
    api.saveAndOpen()
  }

  showInFolder = () => {
    const { api } = this.props
    api.showInFolder()
  }

  deleteAttachment = () => {
    // Placeholder for delete functionality
  }

  getDropDownAttrs = () => {
    const { attachmentObj, enableDelete, downloadable } = this.props

    const { enable_preview, enable_open, enable_save_as, enablePreview, enableOpen, enableSaveAs } =
      attachmentObj

    const items: OmwMenuItem[] = []

    if (enablePreview === true || enable_preview === true) {
      items.push({
        label: i18n.t('editor.menu.preview'),
        key: 'preview',
      })
    }
    if (enableOpen === true || enable_open === true) {
      items.push({
        label: i18n.t('editor.menu.open'),
        key: 'open',
      })
    }
    if (downloadable !== false) {
      items.push({
        label: i18n.t('editor.menu.download'),
        key: 'download',
      })
    }
    if (enable_save_as === true || enableSaveAs === true) {
      items.push({
        label: i18n.t('editor.menu.saveAs'),
        key: 'saveAs',
      })
    }

    if (window.docUtil == null || window.docUtil.parentType !== 'web') {
      items.push(
        {
          label: i18n.t('editor.menu.saveAndOpen'),
          key: 'saveAndOpen',
        },
        { type: 'divider' },
        {
          label: i18n.t('editor.menu.showInFolder'),
          key: 'showInFolder',
        },
      )
    }

    if (enableDelete !== false) {
      items.push({
        label: i18n.t('editor.menu.deleteAttachment'),
        key: 'delete',
      })
    }

    const menu: OmwDropdownMenuConfig = {
      items,
      onClick: (info) => {
        console.log(' --- attachment : ', info.key, info)

        if (info.key === 'download') {
          this.download()
        } else if (info.key === 'delete') {
          this.deleteAttachment()
        } else if (info.key === 'preview') {
          this.showPreview()
        } else if (info.key === 'open') {
          this.open()
        } else if (info.key === 'saveAs') {
          this.saveAs()
        } else if (info.key === 'saveAndOpen') {
          this.saveAndOpen()
        } else if (info.key === 'showInFolder') {
          this.showInFolder()
        }
      },
    }

    const dropdownAttrs = {
      overlayClassName: classNames('contextMenu', 'etv-menu'),
      menu,
      trigger: ['click'] as 'click'[],
    }

    return dropdownAttrs
  }

  cancel = () => {
    const { api } = this.props
    if (this.percent >= 0 && this.percent <= 100) {
      api.cancelDownload()

      this.downloadEnded()
    }
  }

  render() {
    const { percent, isEnabled, thumbLoading } = this.state
    const { enableDelete, downloadable, attachmentObj } = this.props

    const { name, size, mime_type: type } = attachmentObj

    const progressElem =
      percent >= 0 && percent <= 100 ? (
        <OmwProgress className={styles.progress} percent={percent} showInfo={false} />
      ) : (
        ''
      )

    const thumbImg = (
      <div className={styles.fileIcon}>
        <FTIcon colorType="multiColor" fileName={name} />
      </div>
    )

    const wrapperClsMap: Record<string, boolean> = {}
    const clsMap: Record<string, boolean> = {}

    clsMap[styles.icon] = true
    wrapperClsMap.iconItem = true
    clsMap[styles.isProgressing] = percent >= 0 && percent <= 100

    const isClosable = isEnabled && enableDelete !== false

    clsMap[styles.closable] = isClosable

    const nameTxt = name || ''

    // 확장자가 표시되게 하거나, 감추는 걸 여기서 결정.
    let pos = -1 // nameTxt.lastIndexOf('.')

    if (pos < 0) {
      pos = nameTxt.length
    }

    const front = nameTxt.substring(0, pos)
    const end = nameTxt.substring(pos)

    const tooltipAttrs = {
      title: name,
    }

    const filenameElem = (
      <div
        ref={(ref) => {
          this.setFileElem(ref)
        }}
        className={classNames(styles.filename)}
      >
        <span className={styles.front}>{front}</span>
        <span className={styles.end}>{end}</span>
      </div>
    )

    // const fileExt = nameTxt.substring(nameTxt.lastIndexOf('.') + 1, nameTxt.length)

    const dropdownAttrs = this.getDropDownAttrs()

    let rightElem: React.ReactNode = null

    if (percent >= 0 && percent <= 100) {
      rightElem = (
        <div className={styles.menu}>
          <OmwButton
            variant="text"
            icon={<img src={closeIcon} alt="close" />}
            onClick={this.cancel}
          />
        </div>
      )
    } else {
      rightElem =
        downloadable === true ? (
          <OmwDropdownMenu {...dropdownAttrs}>
            <div className={styles.menu}>
              <img src={downIcon} alt="menu" />
            </div>
          </OmwDropdownMenu>
        ) : null
    }

    // sweep이 viewer iframe outerHTML로 사용 여부를 검사하므로 attachment가 마운트되어 있는
    // 동안 path/downloadPath를 attribute로 노출해 보호 신호로 삼는다. download 전에는 attribute 없음.
    const blobUrlAttr: Record<string, string> = {}
    const downloadObj = this.downloadObj
    if (downloadObj?.path != null && downloadObj.path.length > 0) {
      blobUrlAttr['data-blob-url'] = downloadObj.path
    }
    if (downloadObj?.downloadPath != null && downloadObj.downloadPath.length > 0) {
      blobUrlAttr['data-blob-download-url'] = downloadObj.downloadPath
    }

    return (
      <div
        className={classNames(styles.attachmentItemWrapper, 'attachmentItemWrapper', wrapperClsMap)}
        {...blobUrlAttr}
      >
        <div
          className={classNames(styles.attachmentItem, 'attachmentItem', clsMap)}
          data-type={type}
        >
          <OmwSpinner spinning={thumbLoading}>
            <OmwTooltip title={tooltipAttrs.title}>
              <div className={styles.fileInfo}>
                <div role="button" tabIndex={-1} onKeyDown={() => {}} onClick={this.onClick}>
                  {filenameElem}
                  <div className={styles.line2}>
                    <span className={styles.fileSize}>
                      {formatBytes(typeof size === 'number' ? size : parseInt(size, 10), 0, true)}
                    </span>
                  </div>
                  {thumbImg}
                </div>
                {rightElem}
              </div>
            </OmwTooltip>
          </OmwSpinner>
          {progressElem}
        </div>
      </div>
    )
  }
}

export default Attachment
